import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Construction1 from "../Assets/construction1.png";
import Box1 from "../Assets/construction-box-1.png";
import Box2 from "../Assets/construction-box-2.png";
import Box3 from "../Assets/construction-box-3.png";
import Box4 from "../Assets/construction-box-4.png";
import Box5 from "../Assets/construction-box-5.png";

import { useStateContext } from "../contexts/ContextProvider";
import DomainBanner from "./DomainBanner";

const Construction = () => {
  const title = "Construction";
  const body =
    " In the construction industry, where tradition and precision are highly valued, the idea of adopting innovative training methods like eTraining may initially seem challenging. However, eTraining is not just a passing fad – it is a powerful tool with the potential to revolutionize how construction professionals are trained and prepared for the demands of their industry.";

  const { handleShowContact } = useStateContext();

  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <DomainBanner domain="construction" title={title} body={body} />
      <div className="domain-section">
        <div className="domain-container domain-text domain-text-retail">
          <h3>Challenges Addressed by eTraining in Construction</h3>
          <p>
            Traditional training methods can be restrictive and time-consuming.
            Busy schedules often clash with rigid classroom settings, leaving
            knowledge gaps and hindering optimal patient care.
          </p>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          {/* <div className="heading-flex text-center">
            <h3>Why Choose Our e-Training Solutions ?</h3>
          </div> */}
          <div className="domain-features construction">
            <div className="row mb-5">
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box1} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Safety and Compliance</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box2} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Skills Shortage and Training Needs</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-lg-12 d-flex align-items-center justify-content-center">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box3} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Project Management Efficiency</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box4} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Technology Adoption and Innovation</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="box-new2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box5} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3>Quality Assurance and Quality Control</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-features2">
            <div className="domain-text">
              <h3>A <span>Natural Evolution</span> of Training</h3>
              <p>
                Digital training offers a dynamic and efficient way to ensure
                that every member of your team is equipped with the knowledge
                and skills they need to succeed. It empowers construction
                companies to navigate the complex landscape efficiently and
                cost-effectively, offering:
              </p>
            </div>
            <div className="domain-text">
              <div className="row mb-5">
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 61 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.25 15C9.25 18.4518 12.0482 21.25 15.5 21.25C16.4594 21.25 17.3683 21.0338 18.1806 20.6475C18.2085 20.6934 18.2396 20.7379 18.274 20.7809L22.9657 26.6455C20.684 28.7045 19.25 31.6847 19.25 35C19.25 38.957 21.2927 42.4365 24.3811 44.442C24.2972 44.61 24.25 44.7995 24.25 45V47.5C24.25 49.571 25.929 51.25 28 51.25H33C35.071 51.25 36.75 49.571 36.75 47.5V45C36.75 44.7995 36.7028 44.61 36.619 44.442C39.7073 42.4365 41.75 38.957 41.75 35C41.75 31.6847 40.316 28.7045 38.0342 26.6455L42.726 20.7809C42.7605 20.7379 42.7915 20.6934 42.8193 20.6475C43.6317 21.0338 44.5405 21.25 45.5 21.25C48.9518 21.25 51.75 18.4518 51.75 15C51.75 11.5482 48.9518 8.75 45.5 8.75C42.0482 8.75 39.25 11.5482 39.25 15C39.25 16.5945 39.847 18.0496 40.83 19.1538C40.8107 19.1748 40.792 19.1966 40.774 19.2192L36.0015 25.1847C34.7188 24.4643 33.2808 23.988 31.75 23.8188V21.125C34.6028 20.5459 36.75 18.0237 36.75 15C36.75 11.5482 33.9517 8.75 30.5 8.75C27.0483 8.75 24.25 11.5482 24.25 15C24.25 18.0237 26.3972 20.5459 29.25 21.125V23.8188C27.7192 23.988 26.2812 24.4643 24.9986 25.1847L20.2261 19.2192C20.208 19.1966 20.1894 19.1748 20.1701 19.1538C21.1529 18.0496 21.75 16.5945 21.75 15C21.75 11.5482 18.9518 8.75 15.5 8.75C12.0482 8.75 9.25 11.5482 9.25 15ZM15.5 18.75C13.4289 18.75 11.75 17.0711 11.75 15C11.75 12.9289 13.4289 11.25 15.5 11.25C17.5711 11.25 19.25 12.9289 19.25 15C19.25 17.0711 17.5711 18.75 15.5 18.75ZM45.5 18.75C43.429 18.75 41.75 17.0711 41.75 15C41.75 12.9289 43.429 11.25 45.5 11.25C47.571 11.25 49.25 12.9289 49.25 15C49.25 17.0711 47.571 18.75 45.5 18.75ZM26.75 15C26.75 17.0711 28.429 18.75 30.5 18.75C32.571 18.75 34.25 17.0711 34.25 15C34.25 12.9289 32.571 11.25 30.5 11.25C28.429 11.25 26.75 12.9289 26.75 15ZM26.75 47.5V45.61C27.923 46.0245 29.185 46.25 30.5 46.25C31.815 46.25 33.077 46.0245 34.25 45.61V47.5C34.25 48.1903 33.6903 48.75 33 48.75H28C27.3097 48.75 26.75 48.1903 26.75 47.5ZM21.75 35C21.75 39.8325 25.6675 43.75 30.5 43.75C35.3325 43.75 39.25 39.8325 39.25 35C39.25 30.1675 35.3325 26.25 30.5 26.25C25.6675 26.25 21.75 30.1675 21.75 35Z"
                          fill="#05A9A6"
                        />
                      </svg>
                    </span>
                    <span className="txt">Flexibility in Learning</span>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 61 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1736_8529)">
                          <path
                            d="M30.5587 23.0541C34.1179 23.0541 36.9881 20.1837 36.9881 16.6247C36.9881 13.0657 34.1406 10.1953 30.5587 10.1953C26.9995 10.1953 24.1293 13.0657 24.1293 16.6247C24.152 20.2069 27.0224 23.0541 30.5587 23.0541ZM15.6332 41.6766H4.08322C0.340483 41.6766 0.133764 35.959 4.15212 35.959H14.1635L19.904 27.5088C21.6032 25.1897 23.5321 24.0874 26.2645 24.0874H34.8295C37.562 24.0874 39.4907 25.0978 41.1899 27.5088L46.9534 35.959H57.0339C61.0752 35.959 60.8226 41.6766 57.1717 41.6766H45.6217C44.7032 41.6766 43.601 41.355 42.9581 40.3678L38.5492 34.0763L38.5263 49.8284H22.7285L22.7055 34.0763L18.2967 40.3678C17.6538 41.332 16.5517 41.6766 15.6332 41.6766Z"
                            fill="#05A9A6"
                          />
                          <path
                            d="M7.75555 32.1193C11.5013 32.1193 14.5625 29.0783 14.5625 25.3123C14.5625 21.5464 11.5215 18.5054 7.75555 18.5054C3.98961 18.5054 0.96875 21.5665 0.96875 25.3325C0.96875 29.0783 4.00977 32.1193 7.75555 32.1193ZM7.37961 25.8896C6.13109 25.4532 5.35227 24.8222 5.35227 23.7012C5.35227 22.6674 6.03688 21.8551 7.29242 21.6001V20.479H8.23227V21.5464C9.01086 21.5464 9.57477 21.7074 9.99102 21.9291L9.60828 23.2716C9.29937 23.1441 8.79594 22.9292 8.10453 22.9292C7.41312 22.9292 7.03719 23.2716 7.03719 23.6138C7.03719 24.0837 7.47359 24.2649 8.41344 24.6476C9.6957 25.1176 10.2931 25.7687 10.2931 26.836C10.2931 27.9033 9.64203 28.7157 8.26578 29.0244V30.0917H7.32594V29.0579C6.51359 29.0579 5.69469 28.8429 5.29859 28.6215L5.64102 27.2452C6.07742 27.4601 6.76203 27.7151 7.48719 27.7151C8.26578 27.7151 8.64852 27.3727 8.64852 26.9028C8.64852 26.4329 8.27914 26.2388 7.37961 25.8896Z"
                            fill="#05A9A6"
                          />
                          <path
                            d="M57.5066 21.1961L58.1049 20.2469L56.6891 19.3544L56.101 20.287C55.4246 19.9567 54.6873 19.7327 53.911 19.6363V18.7459H54.9411V17.0723H51.2717V18.7459H52.2373V19.63C48.766 20.0327 46.0625 22.99 46.0625 26.5675C46.0625 30.419 49.1959 33.5523 53.0473 33.5523C56.8988 33.5523 60.032 30.4195 60.032 26.568C60.032 24.4103 59.0485 22.4784 57.5066 21.1961ZM53.0471 31.8803C50.1179 31.8803 47.7348 29.4972 47.7348 26.568C47.7348 23.6388 50.1179 21.2556 53.0471 21.2556C55.9763 21.2556 58.3595 23.6388 58.3595 26.568C58.3595 29.4972 55.9763 31.8803 53.0471 31.8803ZM57.3873 26.5359H53.0741V22.2227C55.4513 22.2339 57.3617 24.1619 57.3873 26.5359Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_8529">
                            <rect
                              width="60"
                              height="60"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="txt">Cost Savings</span>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 61 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1736_8535)">
                          <path
                            d="M36.125 29.9999V26.2499H49.5706L45.2713 21.9506L47.9225 19.2993L56.75 28.1249L47.9225 36.9506L45.2713 34.2993L49.5706 29.9999H36.125Z"
                            fill="#05A9A6"
                          />
                          <path
                            d="M32.3745 22.5H28.6245V10.9275L24.3251 15.2269L21.6738 12.5756L30.4995 3.75L39.3251 12.5756L36.6738 15.2269L32.3745 10.9275V22.5Z"
                            fill="#05A9A6"
                          />
                          <path
                            d="M32.375 37.6895V33.7499C32.3728 31.7615 31.5819 29.8551 30.1758 28.4491C28.7698 27.0431 26.8634 26.2522 24.875 26.2499H11.4277L15.7271 21.9506L13.0756 19.2993L4.25 28.1249L13.0756 36.9506L15.7271 34.2993L11.4277 29.9999H24.875C25.8692 30.0012 26.8223 30.3967 27.5253 31.0997C28.2283 31.8027 28.6238 32.7558 28.625 33.7499V37.6895C26.3487 38.1542 24.326 39.4475 22.949 41.3187C21.5721 43.19 20.939 45.5059 21.1725 47.8174C21.406 50.1289 22.4895 52.2713 24.2128 53.8294C25.9362 55.3874 28.1767 56.2501 30.5 56.2501C32.8233 56.2501 35.0638 55.3874 36.7872 53.8294C38.5105 52.2713 39.594 50.1289 39.8275 47.8174C40.061 45.5059 39.4279 43.19 38.051 41.3187C36.674 39.4475 34.6513 38.1542 32.375 37.6895ZM30.5 52.4999C29.3875 52.4999 28.2999 52.17 27.3749 51.552C26.4499 50.9339 25.7289 50.0554 25.3032 49.0275C24.8774 47.9997 24.766 46.8687 24.9831 45.7776C25.2001 44.6864 25.7359 43.6841 26.5225 42.8975C27.3092 42.1108 28.3115 41.5751 29.4026 41.358C30.4938 41.141 31.6248 41.2524 32.6526 41.6781C33.6804 42.1039 34.5589 42.8248 35.177 43.7499C35.7951 44.6749 36.125 45.7624 36.125 46.8749C36.1234 48.3663 35.5302 49.7961 34.4757 50.8506C33.4211 51.9051 31.9913 52.4983 30.5 52.4999Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_8535">
                            <rect
                              width="60"
                              height="60"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="txt">Central Deployment</span>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 61 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M41.75 25.625L53 31.25L30.5 42.5L8 31.25L19.25 25.625M41.75 38.125L53 43.75L30.5 55L8 43.75L19.25 38.125M30.5 7.5L53 18.75L30.5 30L8 18.75L30.5 7.5Z"
                          stroke="#05A9A6"
                          strokeWidth="5"
                        />
                      </svg>
                    </span>
                    <span className="txt">Up-to-Date Training Resources</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1736_8546)">
                          <path
                            d="M12.1257 50C11.4662 49.9906 10.8372 49.721 10.3757 49.25C7.85557 46.7213 5.86197 43.7179 4.51023 40.4137C3.1585 37.1095 2.47547 33.57 2.50067 30C2.50067 22.7065 5.39799 15.7118 10.5552 10.5546C15.7125 5.39731 22.7072 2.5 30.0007 2.5C37.2941 2.5 44.2889 5.39731 49.4461 10.5546C54.6034 15.7118 57.5007 22.7065 57.5007 30C57.5259 33.57 56.8428 37.1095 55.4911 40.4137C54.1394 43.7179 52.1458 46.7213 49.6257 49.25C49.4108 49.5365 49.1368 49.7736 48.8223 49.945C48.5078 50.1165 48.1602 50.2183 47.8029 50.2437C47.4456 50.2691 47.0871 50.2174 46.7515 50.0922C46.4159 49.9669 46.1112 49.771 45.8579 49.5178C45.6046 49.2645 45.4087 48.9598 45.2835 48.6242C45.1582 48.2886 45.1066 47.9301 45.132 47.5728C45.1574 47.2155 45.2592 46.8678 45.4307 46.5534C45.6021 46.2389 45.8391 45.9649 46.1257 45.75C49.211 42.5795 51.2933 38.5697 52.112 34.2221C52.9307 29.8746 52.4496 25.3821 50.7289 21.3065C49.0081 17.2309 46.124 13.753 42.4373 11.3076C38.7505 8.86234 34.4247 7.55814 30.0007 7.55814C25.5767 7.55814 21.2508 8.86234 17.5641 11.3076C13.8773 13.753 10.9932 17.2309 9.27247 21.3065C7.5517 25.3821 7.0706 29.8746 7.88934 34.2221C8.70808 38.5697 10.7903 42.5795 13.8757 45.75C14.1182 45.9725 14.3118 46.2429 14.4442 46.5442C14.5766 46.8454 14.645 47.1709 14.645 47.5C14.645 47.8291 14.5766 48.1546 14.4442 48.4558C14.3118 48.7571 14.1182 49.0275 13.8757 49.25C13.4141 49.721 12.7851 49.9906 12.1257 50Z"
                            fill="#05A9A6"
                          />
                          <path
                            d="M28.2506 18.2498L18.2506 28.1248C17.8175 28.5675 17.5549 29.149 17.5091 29.7666C17.4634 30.3843 17.6375 30.9982 18.0006 31.4998C18.2029 31.8011 18.4716 32.052 18.786 32.2332C19.1004 32.4145 19.4521 32.5213 19.8142 32.5454C20.1763 32.5695 20.5391 32.5104 20.8748 32.3725C21.2105 32.2346 21.5101 32.0216 21.7506 31.7498L27.5006 25.9998V54.9998C27.5006 55.6629 27.764 56.2987 28.2328 56.7676C28.7017 57.2364 29.3376 57.4998 30.0006 57.4998C30.6637 57.4998 31.2995 57.2364 31.7684 56.7676C32.2372 56.2987 32.5006 55.6629 32.5006 54.9998V25.9998L38.2506 31.7498C38.4911 32.0216 38.7907 32.2346 39.1264 32.3725C39.4621 32.5104 39.8249 32.5695 40.187 32.5454C40.5491 32.5213 40.9008 32.4145 41.2152 32.2332C41.5296 32.052 41.7983 31.8011 42.0006 31.4998C42.3638 30.9982 42.5379 30.3843 42.4921 29.7666C42.4464 29.149 42.1837 28.5675 41.7506 28.1248L31.7506 18.2498C31.5281 18.0073 31.2577 17.8137 30.9564 17.6813C30.6552 17.5489 30.3297 17.4805 30.0006 17.4805C29.6715 17.4805 29.346 17.5489 29.0448 17.6813C28.7435 17.8137 28.4731 18.0073 28.2506 18.2498Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_8546">
                            <rect width="60" height="60" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="txt">Onboarding and Retention</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          <p className="domain-text3">
            In a constantly evolving industry, continuous learning and
            upskilling are imperative. eTraining is a strategic investment in
            the future of your construction business, empowering your workforce
            for success.
          </p>
        </div>
      </div>

      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Construction;
